/* eslint-disable react-hooks/exhaustive-deps */
import { Button, makeStyles } from "@material-ui/core";
import { cloneDeep } from "lodash";
import React, { useContext, useRef, useState } from "react";
import { SyntheticEvent } from "react-draft-wysiwyg";
import { CurrencyContext } from "../../../contexts/AppContext";
import { useDohone } from "../../../Hooks/useDohone";
import { useUser } from "../../../Hooks/UserHooks";
import Spin from "../../../images/Spin";
import { serverConfig } from "../../../utils/config";
import { ConvertedDeviseWithoutMoneySign } from "../../../utils/CurrencyConvertFunction";
import { IBookingPayment } from "../../../utils/PaymentInterfaces";
import { ConfirmationReservationService } from "../../Reservation/services/ConfirmationReservationService";
import { FlashErrorOccured } from "../FlashMessage";
import { useTranslation } from "react-i18next";
import { ITraveller } from "../../../utils/ReservationInterfaces";

const styles = makeStyles(() => ({
    btn: {
        width: 180,
        height: 40,
        color: "#FFFFFF",
        textTransform: "initial",
        fontSize: 14,
        fontFamily: "Josefin Sans",
        marginBottom: 18,
        borderRadius: 100,
        background: "#890608",
        "&:hover": {
            background: "#EA7606",
        },
    },
    errorText: {
        color: "#ff0000",
        fontSize: "0.8rem",
        marginTop: "8px"
    }
}));

const reservationService = new ConfirmationReservationService();

export function DohonePayementButton(props: { paymentData: IBookingPayment, paidByCredit: number, travellerData?: ITraveller }) {

    /*console.group('[DohonePayment] Initial Data');
    console.log('[8] Inside DohoneButton - received props:', {
        amount: props.paymentData.transaction.amount.total,
        currency: props.paymentData.transaction.items.booking.announce.devise,
        rawData: props.paymentData
    }); */


    console.groupEnd(); 
    const classes = styles();
    const dohone = useDohone();
    const formRef = useRef<HTMLFormElement | null>(null);
    const { user } = useUser();
    const { currency } = useContext(CurrencyContext);
    const [loading, setLoading] = useState(false);
    const [montant, setMontant] = React.useState(0);
    const [dohoneLoading, setDohoneLoading] = useState(false);
    const [dohoneError, setDohoneError] = useState(false);
    const total = props.paymentData.transaction.amount.total;
    const { t } = useTranslation<'common'>();

    // Automatic Dohone info fetch on mount
    React.useEffect(() => {
        if (!dohone.info && !dohoneLoading && !dohoneError) {
            setDohoneLoading(true);
            dohone.refresh()
                .catch(() => setDohoneError(true))
                .finally(() => setDohoneLoading(false));
        }
    }, [dohone.info]);

    React.useEffect(() => {
       /*console.log('[DohonePayment] Starting currency conversion', {
            from: props.paymentData.transaction.items.booking.announce.devise,
            to: "XAF",
            amount: total
        })*/
    
        ConvertedDeviseWithoutMoneySign(
            props.paymentData.transaction.items.booking.announce.devise,
            "XAF",
            total
        )
            .then((price: any) => {
                /*console.log('[DohonePayment] Conversion result', {
                    originalAmount: total,
                    convertedAmount: price,
                    rate: price / total
                }); */
                setMontant(price);
            })
            .catch((error) => {
                console.error('[DohonePayment] Conversion failed', error);
            });
    }, [total, currency]);

    const handleRetry = async () => {
        setDohoneError(false);
        setDohoneLoading(true);
        try {
            await dohone.refresh();
        } catch (error) {
            setDohoneError(true);
        } finally {
            setDohoneLoading(false);
        }
    };


    const handleSubmit = (e: SyntheticEvent) => {
        e.preventDefault();

        /*console.group('[DohonePayment] Submission Data');
        console.log('Original amount:', total);
        console.log('Converted amount:', montant);
        console.log('Rounded amount:', Math.ceil(total));
        console.log('Currency:', props.paymentData.transaction.items.booking.announce.devise);
        console.groupEnd(); */


        if (!formRef.current || montant === 0) return;

        const clonePaymentData = cloneDeep(props.paymentData);
        clonePaymentData.transaction.amount.total = Math.ceil(total);

        const tempReservation = {
            ...clonePaymentData.transaction.items.booking,
            paidByCredit: props.paidByCredit,
            traveller: props.travellerData || clonePaymentData.transaction.items.booking.traveller
        };

        setLoading(true);
        reservationService
            .createTemporary(tempReservation)
            .then((response) => {
                if (!formRef.current) return;
                (formRef.current.elements as any)["rI"].value = response.tempId;
                formRef.current.submit();
            })
            .catch((err) => {
                FlashErrorOccured();
                //console.log("erreur", err);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    if (dohoneError) {
        return (
            <div>
                <Button 
                    className={classes.btn}
                    onClick={handleRetry}
                >
                    {t("label.retry_payment")}
                </Button>
                <div className={classes.errorText}>
                    {t("error.payment_connection")}
                </div>
            </div>
        );
    }

    if (!dohone.info) {
        return null; // Or loading skeleton
    }


    return (
        <form
            ref={formRef}
            action="https://www.my-dohone.com/dohone/pay"
            method="post"
            onSubmit={handleSubmit}
        >
            <input type="hidden" name="cmd" value="start" />
            <input
                type="hidden"
                name="rN"
                value={user.firstName + " " + user.lastName}
            />
            <input
                type="hidden"
                name="rT"
                value={user.phone || "237699982782"}
            />
            <input type="hidden" name="rH" value={dohone.info.codeMarchand} />
            <input type="hidden" name="rI" value="xxx" />
            <input type="hidden" name="rMt" value={Math.ceil(total)} />
            <input type="hidden" name="rDvs" value="XAF" />
            <input
                type="hidden"
                name="source"
                value={dohone.info.commercialName}
            />
            <input
                type="hidden"
                name="endPage"
                value={`${window.location.origin}/reservation/payment_success`}
            />
            <input
                type="hidden"
                name="notifyPage"
                value={`${serverConfig.ApiRoot}/dohone/notification`}
            />
            <input
                type="hidden"
                name="cancelPage"
                value={`${window.location.href}&failed=true`}
            />
            <Button
                variant="text"
                type="submit"
                className={classes.btn}
                disabled={loading || montant === 0}
            >
                {loading && (
                    <Spin style={{ height: 16, width: 16, marginRight: 8 }} />
                )}{" "}
                {t("label.payer-maintenant")}
            </Button>
        </form>
    );
}
